import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Cases from './views/Cases.vue'
import Join from './views/Join.vue'
import Contact from './views/Contact.vue'
import Services from './views/Services.vue'
import Team from './views/Team.vue'
import Training from './views/Training.vue'
import Events from './views/Events.vue'
import Honour from './views/Honour.vue'
import About from './views/About.vue'
import LowIE from './views/LowIE.vue'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/home',
      name: 'home',
      cname: '首页',
      component: Home
    },
    {
      path: '/cases',
      name: 'cases',
      cname: '品牌案例',
      component: Cases
    },
    {
      path: '/services',
      name: 'services',
      cname: '服务',
      component: Services
    },
    {
      path: '/team',
      name: 'team',
      cname: '公司架构',
      component: Team
    },
    {
      path: '/training',
      name: 'training',
      cname: '培训',
      component: Training
    },
    {
      path: '/about',
      name: 'about',
      cname: '关于我们',
      component: About,
      children: [
        {
          path: '',
          redirect: 'events'
        },
        {
          path: 'events',
          name: 'events',
          cname: '大事记',
          component: Events
        },
        {
          path: 'honour',
          name: 'honour',
          cname: '银都荣誉',
          component: Honour
        }/*,
        {
          path: 'culture',
          name: 'culture',
          cname: '企业文化',
          component: Culture
        } */
      ]
    },
    {
      path: '/join',
      name: 'join',
      cname: '加入我们',
      component: Join
    },
    {
      path: '/contact',
      name: 'contact',
      cname: '联系我们',
      component: Contact
    },
    {
      path: '/lowie',
      name: 'lowie',
      component: LowIE
    }
  ]
})
